import { LOAD_STATE } from '@shared/axios';
import { createReducer, INITIAL_STATE } from '../../shared/redux';
import { getFeaturesInitialState, parseUserFeaturesData } from './feature-toggle.utils';
import { FeatureToggleData } from './feature-toggle.utility-types';

import { getUserFeaturesConfig } from './feature-toggle.api';

const GET_USER_FEATURES_REQUEST_CALLED = '@feature-toggle/GET_USER_FEATURES_REQUEST_CALLED';
const GET_USER_FEATURES_REQUEST_SUCCEEDED = '@feature-toggle/GET_USER_FEATURES_REQUEST_SUCCEEDED';
const GET_USER_FEATURES_REQUEST_FAILED = '@feature-toggle/GET_USER_FEATURES_REQUEST_FAILED';

export const getUserFeatures = () => ({
    type: GET_USER_FEATURES_REQUEST_CALLED,
    actionTypes: {
        success: GET_USER_FEATURES_REQUEST_SUCCEEDED,
        fail: GET_USER_FEATURES_REQUEST_FAILED,
    },
    config: getUserFeaturesConfig(),
});

export interface FeatureToggleReducer {
    featureToggle: FeatureToggleData,
}

const initialState: FeatureToggleData = {
    loadState: LOAD_STATE.LOADING,
    data: {
        features: getFeaturesInitialState(),
    },
    error: null,
};

export const featureToggleReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_USER_FEATURES_REQUEST_CALLED]: state => ({
        ...state,
    }),
    [GET_USER_FEATURES_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: parseUserFeaturesData(state.data, action.payload.data.features),
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [GET_USER_FEATURES_REQUEST_FAILED]: (state, action) => ({
        ...state,
        data: initialState.data,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
});
